import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/common/button'
import RelatedProductSectionSkeleton from 'components/pdp/related-section/skeleton'
import ProductList from 'components/product/product-list'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const RelatedProductLayer = ({
  showTwoPerRow,
  customSkeletonProps,
  displayBadges,
  displayCTA,
  displaySwatches,
  elementID,
  isPDPRelatedProduct,
  onClick,
  productId,
  products,
  refType,
  subTitle,
  t,
  title,
  displayHoverInteractions,
  displayQuickAddToBag,
}) => {
  if (!products?.length) {
    return customSkeletonProps ? (
      <RelatedProductSectionSkeleton {...customSkeletonProps} />
    ) : null
  }

  return (
    <div className="pdp__related__container" id={elementID}>
      <style jsx>{styles}</style>
      {title && (
        <span
          className={clsx('related-title', {
            [Typo.h6]: isPDPRelatedProduct,
            [Typo.title3]: !isPDPRelatedProduct,
          })}
        >
          {title}
        </span>
      )}
      {subTitle && (
        <span className={clsx('related-subtitle', Typo.caption)}>
          {subTitle}
        </span>
      )}
      <ProductList
        showTwoPerRow={showTwoPerRow}
        displayBadges={displayBadges}
        displayDescription
        displayPrice
        displaySwatches={displaySwatches}
        displayWishlistIcon
        list={products}
        refId={productId}
        refType={refType}
        promptLocation="wishlist_product"
        displayHoverInteractions={displayHoverInteractions}
        displayQuickAddToBag={displayQuickAddToBag}
      />
      {displayCTA && (
        <Button className="related-button" onClick={onClick}>
          {hasLocizeTranslation(t, 'PDP_RECOMMENDED_LAYER_CTA', 'see more')}
        </Button>
      )}
    </div>
  )
}

RelatedProductLayer.defaultProps = {
  customSkeletonProps: null,
  displayBadges: false,
  displayCTA: false,
  displaySwatches: false,
  elementID: '',
  isPDPRelatedProduct: true,
  onClick: null,
  subTitle: null,
  displayHoverInteractions: false,
  displayQuickAddToBag: false,
  showTwoPerRow: false,
  title: null,
}

RelatedProductLayer.propTypes = {
  showTwoPerRow: PropTypes.bool,
  displayHoverInteractions: PropTypes.bool,
  displayQuickAddToBag: PropTypes.bool,
  customSkeletonProps: PropTypes.shape({}),
  displayBadges: PropTypes.bool,
  displayCTA: PropTypes.bool,
  displaySwatches: PropTypes.bool,
  elementID: PropTypes.string,
  isPDPRelatedProduct: PropTypes.bool,
  onClick: PropTypes.func,
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  refType: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func.isRequired,
}

export default withI18next()(RelatedProductLayer)
